import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AdminAudioplayersNewRoute extends Route {
  // Services
  @service breadcrumb;

  // Hooks
  model() {
    return this.breadcrumb.findRouteModelOrCreateRecord('audioplayer');
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
